import { createFileRoute } from "@tanstack/react-router";

import { AdminTabsLayout } from "src/components/AdminTabsLayout";

export const FEATURE_FLAGS_DEFAULT_PAGE_SIZE = 20;

export const Route = createFileRoute("/_auth/_admin/admin/feature-flags")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb() {
      return {
        label: "Feature flags",
        href: "/admin/feature-flags",
      };
    },
  },
});

function RouteComponent() {
  return (
    <AdminTabsLayout
      label="Feature flag sections"
      tabs={[
        { to: "/admin/feature-flags", label: "Feature flags", exact: true },
        { to: "/admin/feature-flags/access", label: "Access" },
      ]}
    />
  );
}
